import { baseClasses } from '@weatherbug/common';
import { WeatherWidgetsProvider } from '../providers/weatherWidgetsProvider';

const { AsyncAction } = baseClasses;

export const GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE = new AsyncAction('GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE');
export const GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID = new AsyncAction('GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID');
export const GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP = 'GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP';
export const GET_WEATHER_WIDGET_CURRENT_STATION_OBS = new AsyncAction('GET_WEATHER_WIDGET_CURRENT_STATION_OBS');
export const GET_WEATHER_WIDGET_HOURLY_FORECAST = new AsyncAction('GET_WEATHER_WIDGET_HOURLY_FORECAST');
export const GET_WEATHER_WIDGET_FORECAST_ICON = new AsyncAction('GET_WEATHER_WIDGET_FORECAST_ICON');

export type GetWeatherWidgetLocByPostalCodeActionType = {
    type: typeof GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE;
    payload: Promise<any>;
}

export type GetWeatherWidgetLocByCityIdActionType = {
    type: typeof GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID;
    payload: Promise<any>;
}

export type GetWidgetCurrentStationObsType = {
    type: typeof GET_WEATHER_WIDGET_CURRENT_STATION_OBS;
    payload: Promise<any>;
}

export type GetWeatherWidgetHourlyForecastType = {
    type: typeof GET_WEATHER_WIDGET_HOURLY_FORECAST;
    payload: Promise<any>;
}

export type GetWeatherWidgetForecastIconType = {
    type: typeof GET_WEATHER_WIDGET_FORECAST_ICON;
    payload: Promise<any>;
}

interface UserLocationDataFromIP {
    widgetLocationName: string;
    widgetLocationLat: number;
    widgetLocationLon: number;
}

export type GetWeatherWidgetLocFromUserIpType = {
    type: typeof GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP;
    payload: UserLocationDataFromIP;
}

export function getWidgetLocationDetailsFromPostalCodeAction(
    postalCode: string, 
    maxResults: number, 
    locationBaseUrl: string, 
    authId: string, 
    secret: string, 
    verbose: boolean): GetWeatherWidgetLocByPostalCodeActionType {
    
    return {
        type: GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE.base,
        payload: getLocationDetailsFromPostalCode(postalCode, maxResults, locationBaseUrl, authId, secret, verbose)
    };
}

async function getLocationDetailsFromPostalCode(postalCode: string, maxResults: number, locationBaseUrl: string, authId: string, secret: string, verbose: boolean): Promise<any> {
    const weatherWidgetProvider = new WeatherWidgetsProvider(locationBaseUrl, authId, secret);
    const result = await weatherWidgetProvider.getLocationDetailsFromPostalCode(postalCode, maxResults, verbose);
    return result;
}

export function getWidgetLocationDetailsByCityIdAction(
    cityId: string,  
    locationBaseUrl: string, 
    authId: string, 
    secret: string): GetWeatherWidgetLocByCityIdActionType {
    
    return {
        type: GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID.base,
        payload: getLocationDetailsByCityId(cityId, locationBaseUrl, authId, secret)
    };
}

async function getLocationDetailsByCityId(cityId: string, locationBaseUrl: string, authId: string, secret: string): Promise<any> {
    const weatherWidgetProvider = new WeatherWidgetsProvider(locationBaseUrl, authId, secret);
    const result = await weatherWidgetProvider.getLocationDetailsFromCityId(cityId);
    return result;
}

export function getWidgetCurrentStationObs(
    obsBaseUrl: string,
    authId: string, 
    secret: string,
    location: string, 
    locationtype: string, 
    offset: number, 
    units: string
): GetWidgetCurrentStationObsType {

    return {
        type: GET_WEATHER_WIDGET_CURRENT_STATION_OBS.base,
        payload: getWidgetStationObs(obsBaseUrl, authId, secret, location, locationtype, offset, units)
    };
}

async function getWidgetStationObs(
    obsBaseUrl: string,
    authId: string, 
    secret: string,
    location: string, 
    locationtype: string, 
    offset: number, 
    units: string): Promise<any> {

    const weatherWidgetProvider = new WeatherWidgetsProvider(obsBaseUrl, authId, secret);
    const result = await weatherWidgetProvider.getWidgetStationObs(location, locationtype, offset, units, false, false);
    return result;
}

export function getWidgetHourlyForecastAction(
    forecastBaseUrl: string,
    authId: string, 
    secret: string,
    location: string, 
    locationtype: string, 
    offset: number, 
    units: string,
    verbose?: boolean, 
    refresh?: boolean
): GetWeatherWidgetHourlyForecastType {
    
    return {
        type: GET_WEATHER_WIDGET_HOURLY_FORECAST.base,
        payload: getWidgetHourlyForecast(forecastBaseUrl, authId, secret, location, locationtype, offset, units, verbose, refresh)
    };
}

async function getWidgetHourlyForecast(
    forecastBaseUrl: string,
    authId: string, 
    secret: string,
    location: string, 
    locationtype: string, 
    offset: number, 
    units: string,
    verbose = false, 
    refresh = false): Promise<any> {

    const weatherWidgetProvider = new WeatherWidgetsProvider(forecastBaseUrl, authId, secret);
    const result = await weatherWidgetProvider.getWidgetHourlyForecast(location, locationtype, offset, units, verbose, refresh);
    return result;
}

export function getWeatherWidgetForecastIconAction(
    contentManagementBaseUrl: string,
    authId: string,
    secret: string,
    resourceList: string,
    stdParameters?: object
): GetWeatherWidgetForecastIconType {
    
    return {
        type: GET_WEATHER_WIDGET_FORECAST_ICON.base,
        payload: getWeatherWidgetForecastIcon(contentManagementBaseUrl, authId, secret, resourceList, stdParameters)
    };
}

async function getWeatherWidgetForecastIcon(
    contentManagementBaseUrl: string,
    authId: string,
    secret: string,
    resourceList: string,
    stdParameters?: object
): Promise<any> {

    const weatherWidgetProvider = new WeatherWidgetsProvider(contentManagementBaseUrl, authId, secret);
    const result = await weatherWidgetProvider.getWidgetForecastIcon(resourceList, stdParameters);
    return result;
}

export function getDefaultWidgetLocationFromUserIpAction(locationName: string, lat: number, lon: number): GetWeatherWidgetLocFromUserIpType {

    return {
        type: GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP,
        payload: {
            widgetLocationName: locationName,
            widgetLocationLat: lat,
            widgetLocationLon: lon
        }
    };
}